import { useContext } from "react";

import { MapRouteName } from "src/helpers/mapConstants";
import { formatTime } from "src/lib/stringFormats";
import TimeLabel from "../ui/TimeLabel";
import RouteLineExample from "./RouteLineExample";
import { LanguageContext } from "../languageContext";
import { TextId } from "src/Translations";

export function TravelTimesTable({ travelTimes }: any) {
  const { translate } = useContext(LanguageContext);

  return (
    <div className="flex flex-col gap-4">
      <h5 className="mb-4 text-[18px] font-bold">{translate("travelTimes")}</h5>
      {travelTimes ? (
        Object.keys(travelTimes).map((scenario) => {
          if (travelTimes[scenario as MapRouteName]) {
            return (
              <div
                key={scenario}
                className="flex flex-1 justify-between space-x-2"
              >
                <div className="flex space-x-2 items-center">
                  <RouteLineExample scenario={scenario as MapRouteName} />
                  <p>{translate(`altName-${scenario}` as TextId)}</p>
                </div>
                <TimeLabel
                  {...formatTime(travelTimes[scenario as MapRouteName] ?? 0)}
                />
              </div>
            );
          } else {
            return <></>;
          }
        })
      ) : (
        <p className="text-gray-400">{translate("toSeeResults")}</p>
      )}
    </div>
  );
}
